import React, { useState, useEffect } from 'react';
import Loader from './Loader';
import cryptopage from '../assets/cryptopage.json'

const Cmcwidget = () => {

    const [ctc, setCtc] = useState(1);
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            cryptopage.filter(item => window.location.href.split('/').slice(-1)[0] === item.title.trim().replace(/ /g, '-').toLowerCase())
            .map(item => {
                setCtc(item.field_crypto_symbol_id)
                return null
            })
            setLoader(false)
        };
        fetchData()
    }, [ctc])

    const url = "https://files.coinmarketcap.com/static/widget/currency.js";

    useEffect(() => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        document.body.appendChild(script);
        return () => {
          document.body.removeChild(script);
        };
    }, [ctc]);
    return (
        <div>
            {!loader ? <div className="coinmarketcap-currency-widget"
                data-currencyid={ctc} data-base="USD" data-secondary="" data-ticker="true"
                data-rank="true" data-marketcap="true" data-volume="true" data-statsticker="true" data-stats="USD"></div> : <Loader /> }
        </div>
    );
}

export default Cmcwidget;